import ky from 'ky';
import { getAuthToken } from 'utils/auth';
import { oidcConfig, basePath } from 'config';

const createKyClientInternal = async () => {
  const accessToken = await getAuthToken(oidcConfig);
  return ky.create({
    headers: {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json;charset=utf-8',
      Accept: 'application/json;charset=utf-8',
    },
    prefixUrl: basePath,
  });
};

let kyClientPromise = createKyClientInternal();

// This is useful when the user is logged out and the login call back function is called.
export const refreshKyClientAccessToken = async () => {
  const accessToken = await getAuthToken(oidcConfig);
  //extend the already resolved promise to return a new client.
  kyClientPromise = kyClientPromise.then((kyClient) =>
    kyClient.extend({
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    })
  );
};

// Returns the same resolved promise everytime.
export const getKyClient = async () => {
  return kyClientPromise;
};
